import { render, staticRenderFns } from "./ziarat-register.html?vue&type=template&id=60894870&scoped=true&"
import script from "./ziarat-register.vue?vue&type=script&lang=ts&"
export * from "./ziarat-register.vue?vue&type=script&lang=ts&"
import style0 from "./ziarat-register.scss?vue&type=style&index=0&id=60894870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60894870",
  null
  
)

export default component.exports